import { z } from 'zod';

// ============================================================================
// PARAMS
// ============================================================================

// Conservative key shape — alphanumerics + `:`, `_`, `.`, `-` only. Lets us
// namespace via `layout:streams`, `layout:patient:<patientId>`, etc., while
// keeping the column safe to log without sanitisation.
export const preferenceKeyParam = z.object({
  key: z.string().min(1).max(120).regex(/^[a-zA-Z0-9_:.-]+$/),
});
export type PreferenceKeyParam = z.infer<typeof preferenceKeyParam>;

// ============================================================================
// BODIES
// ============================================================================

// `value` is opaque server-side — schema validation per-key is the client's
// responsibility. The JSON column accepts anything serialisable.
export const upsertPreferenceBody = z.object({
  value: z.unknown(),
});
export type UpsertPreferenceBody = z.infer<typeof upsertPreferenceBody>;

// ============================================================================
// RESPONSES
// ============================================================================

export const preferenceResponse = z.object({
  key: z.string(),
  value: z.unknown(),
  updatedAt: z.date(),
});
export type PreferenceResponse = z.infer<typeof preferenceResponse>;

export const preferencesListResponse = z.object({
  items: z.array(preferenceResponse),
});
export type PreferencesListResponse = z.infer<typeof preferencesListResponse>;
